/* __next_internal_client_entry_do_not_use__ SDUIRotatingSectionComponentRenderer auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { IComponent } from "@faire/web-api--source/indigofair/data/IComponent";
import React from "react";
import classNames from "classnames";
import { SDUIComponentRenderer } from "../../__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { useAnimatedRotation } from "./useAnimatedRotation";
// eslint-disable-next-line import/no-unassigned-import
import './styles/SDUIRotatingSectionRenderer.tw.css';
export var SDUIRotatingSectionComponentRenderer = function(param) {
    var section = param.section, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData, loadTimingRef = param.loadTimingRef;
    var _section_rotating_section;
    var _ref = (_section_rotating_section = section.rotating_section) !== null && _section_rotating_section !== void 0 ? _section_rotating_section : {}, components = _ref.components, rotationDelayMs = _ref.delay;
    var _useAnimatedRotation = useAnimatedRotation(components, rotationDelayMs), isAnimationInView = _useAnimatedRotation.isAnimationInView, currentIndex = _useAnimatedRotation.currentIndex, hasCurrentBannerBeenViewed = _useAnimatedRotation.hasCurrentBannerBeenViewed, containerRef = _useAnimatedRotation.containerRef, resumeScroll = _useAnimatedRotation.resumeScroll, pauseScroll = _useAnimatedRotation.pauseScroll;
    if (!components || !components[currentIndex]) {
        return null;
    }
    var _components_currentIndex;
    return /*#__PURE__*/ _jsx("div", {
        className: "col-start-1 row-start-1",
        onMouseEnter: pauseScroll,
        onMouseLeave: resumeScroll,
        ref: containerRef,
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames("h-full flex items-center", isAnimationInView ? "animated-in-container" : "animated-out-container"),
            children: /*#__PURE__*/ _jsx(SDUIComponentRenderer, {
                isPrimaryContent: true,
                component: (_components_currentIndex = components[currentIndex]) !== null && _components_currentIndex !== void 0 ? _components_currentIndex : IComponent.build({}),
                componentRenderers: componentRenderers,
                sectionLoggingParams: sectionLoggingData,
                loadTimingRef: loadTimingRef,
                disableViewEvent: hasCurrentBannerBeenViewed
            })
        })
    });
};
